import React from 'react'
import { type ControllerRenderProps } from 'react-hook-form'

import { type InputValues } from './utils'

type Diffs = InputValues['diffs']

export const diffsContext = React.createContext<Diffs>([])

type RenderSelector = (
  field:
    | ControllerRenderProps<InputValues, `diffs.${number}.0`>
    | ControllerRenderProps<InputValues, `diffs.${number}.1`>,
  anotherFieldValue: string | null,
) => React.ReactNode

export const renderSelectorContext = React.createContext<RenderSelector>(
  () => null,
)

type OnExecute = (diffs: Diffs) => void

export const onExecuteContext = React.createContext<OnExecute | undefined>(
  undefined,
)
